import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';
import { useUserStore } from '@/stores/userStore';

/** 充值记录代码加载时的占位，按导出权限预留按钮并保留初始无分页布局 */
export function RechargeRecordsSkeleton() {
  const permissionCodes = useUserStore((state) => state.userInfo?.permissionCodes);
  const canExport = permissionCodes?.includes('business:recharge:export');

  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <ListPageSkeleton
        columnCount={9}
        showPagination={false}
        contentClassName="gap-4 p-6"
        filterArea={
          <div className="flex items-end justify-between gap-4 pb-4">
            {/** 账户、申请类型、申请状态和日期 */}
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-4">
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[260px]" />
                <div className="flex items-center gap-2">
                  <Skeleton className="h-9 w-20" />
                  <Skeleton className="h-9 w-20" />
                  {/** 导出入口沿用页面权限，减少加载后的筛选区宽度变化 */}
                  {canExport && <Skeleton className="h-9 w-20 ml-2" />}
                </div>
              </div>
            </div>
            {/** 列配置入口 */}
            <Skeleton className="h-9 w-24 shrink-0" />
          </div>
        }
      />
    </div>
  );
}
